import { render, staticRenderFns } from "./menu2.vue?vue&type=template&id=69cfbf92&scoped=true"
import script from "./menu2.vue?vue&type=script&lang=js"
export * from "./menu2.vue?vue&type=script&lang=js"
import style0 from "./menu2.vue?vue&type=style&index=0&id=69cfbf92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cfbf92",
  null
  
)

export default component.exports